import React, { memo, useCallback, useState } from "react";
import { useT } from "@al/next/al-ex";
import cls from "classnames";

import HalfPopup from "~/components/ui/HalfPopup";

import FunctionItem from "../item";

import styles from "./index.scss";
import { Props } from "./types";
import { getInfoValue } from "./utils";

const Description: React.FC<Props> = (props) => {
  const t = useT();
  const { specificationInfos } = props;
  const [visible, setVisible] = useState(false);

  const closePopup = useCallback((): void => {
    setVisible(false);
  }, []);

  const showPopup = useCallback((): void => {
    setVisible(true);
  }, []);

  return (
    <div className={styles.box}>
      <FunctionItem
        title={t("规格")}
        subTitleClassName={styles.specification_sub_title}
        subTitle={specificationInfos?.slice(0, 3).map((item, i) => (
          <div className={styles.parameters_item} key={item.name + "" + i}>
            <div className={styles.label}>{item.name}</div>
            <div className={styles.content}>{getInfoValue(item.desc)}</div>
          </div>
        ))}
        onClick={showPopup}
        itemClassName={styles.specification_item}
      />
      <HalfPopup
        visible={visible}
        title={t("规格")}
        onMaskClick={closePopup}
        onClose={closePopup}
        headerTextAlign="left"
        destroyOnClose
      >
        <div className={styles.wrap}>
          {specificationInfos?.map((item, i) => (
            <div className={cls(styles.parameters_item, styles.popup_item)} key={item.name + "" + i}>
              <div className={styles.popup_label}>{item.name}</div>
              <div className={styles.popup_content}>{getInfoValue(item.desc)}</div>
            </div>
          ))}
        </div>
      </HalfPopup>
    </div>
  );
};

export default memo(Description);
